import * as React from 'react'
import ASK1 from './images/courses1.png';
import ASK2 from './images/courses2.png';
import ASK3 from './images/courses3.png';
import Whirligig from 'react-whirligig';
import './css/UpcomingCoursesSlider.scss';
import {
    isMobileOnly,
    isTablet
} from "react-device-detect";

const UpcomingCoursesSlider = () => {

    let height,visibleSlides;

    if(isMobileOnly){
        height="170px";
        visibleSlides=1.3;
    }
    else if(isTablet){
        height="350px";
        visibleSlides=1.3;
    }

    return (
        <div className="container mt-5 mb-5 UpcomingCoursesSlider">
            <h1 className="Upcoming-online-course">Upcoming online course</h1>
            <div>
                <Whirligig
                    slideBy={1}
                    visibleSlides={visibleSlides}
                >
                    <div className="card coloumn mb-4">
                        <img className="card-img-top image" src={ASK1} alt="ASK1" style={{height:height}}></img>
                        <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                            <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="card-img-top image" src={ASK2} alt="ASK2" style={{height:height}}></img>
                        <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                            <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="card-img-top image" src={ASK3} alt="ASK3" style={{height:height}}></img>
                        <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                            <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
                        </div>
                    </div>                    
                </Whirligig>
            </div>
            <h2 className="Show-all-online-courses"><b>Show all online courses</b> &gt;</h2>
        </div>
    )
}

export default UpcomingCoursesSlider;